import { createAsyncAtom } from '../../lib';

const unstakeAmountAtom = createAsyncAtom<string | null>(async () => null);

export default unstakeAmountAtom;
